var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4B55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADFF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home",
    className: "cls-1",
    d: "M506.096,264.697c-3.901,3.875-8.999,5.812-14.096,5.812c-5.141,0-10.279-1.969-14.188-5.904 L462,248.688v72.82c0,11.046-8.954,20-20,20s-20-8.954-20-20V208.425L269.893,55.315c-7.464-6.394-18.454-6.418-25.947-0.055 L89.991,208.911c0.006,0.198,0.009,0.397,0.009,0.597v212c0,22.056,17.944,40,40,40h52v-163c0-11.046,8.954-20,20-20h110 c11.046,0,20,8.954,20,20v163h50c22.056,0,40-17.944,40-40c0-11.046,8.954-20,20-20s20,8.954,20,20c0,44.112-35.888,80-80,80h-70 c-11.046,0-20-8.954-20-20v-163h-70v163c0,11.046-8.954,20-20,20h-72c-44.112,0-80-35.888-80-80V248.824l-15.872,15.841 c-7.817,7.802-20.48,7.79-28.284-0.028c-7.803-7.818-7.79-20.481,0.028-28.285L216.161,26.477c0.269-0.268,0.545-0.529,0.829-0.782 c22.842-20.335,57.227-20.262,79.982,0.169c0.282,0.254,0.559,0.516,0.826,0.786l208.39,209.763 C513.974,244.249,513.932,256.912,506.096,264.697z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.bb238d30ae06e197cc6dc91652bfbd6a.svg";
export { ForwardRef as ReactComponent };